<div class="item-distill-dialog">
  <div class="header">
    <span class="title" [ghs-label]="'game.items.share'" [ghs-label-args]="['data.items.' + item.edition + '-' + item.id]"></span>
  </div>

  <div class="item">
    <ghs-item [item]="item" [reveal]="true" [flipped]="true"></ghs-item>
  </div>

  <div class="characters">
    @for (char of characters | trackUUID; track char._trackUUID) {
      <div class="character" (click)="toggleSelected(char)" [ngClass]="{ selected: selected === char }">
        <img class="icon" [src]="char.iconUrl" />
        <span class="name">
          {{ gameManager.characterManager.characterName(char, true) }}
        </span>
      </div>
    }
  </div>

  <div class="menu">
    <a class="cancel" (click)="close()"><span [ghs-label]="'cancel'"></span></a>
    <a class="apply" [ngClass]="{ disabled: !selected }" ghs-pointer-input (singleClick)="apply()">
      <span [ghs-label]="selected ? 'game.items.share.apply' : 'game.items.share.select'"></span
    ></a>
  </div>
</div>
